<template lang="pug">
  form
    modal(
    v-if="showModal"
    :mode="'notification'"
    :modalData="modalData"
    @close="showModal = false"
    )
    .form
      .form__elem
        .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error': errorFieldOldPAssword }"
        )
          .form-elem__title Старый пароль
          .form-elem__main
            input.input(
            type="password"
            v-model="fields.old_password"
            @input="onInputChange('old_password')"
            )
      .form__elem
        .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error': errorFieldPassword }"
        )
          .form-elem__title Новый пароль
          .form-elem__main
            input.input(
            type="password"
            v-model="fields.password"
            @input="onInputChange('password')"
            )
      .form__elem
        .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error': errorFieldPassword2 }"
        )
          .form-elem__title Новый пароль еще раз
          .form-elem__main
            input.input(
            type="password"
            v-model="fields.password2"
            @input="onInputChange('password2')"
            )
      .form__elem.form__elem_align-right
        .form-elem.form-elem
          .form-elem__main
            button.button.button_paint-main(
            @click.prevent="onButtonClick"
            ) Изменить пароль
            .form-elem__error(
            v-if="currentErrorMessage.length > 0"
            ) {{ currentErrorMessage }}
</template>

<script>
import { mapActions } from "vuex";
import Modal from "../modal/modal";

export default {
  name: "form-password",
  components: { Modal },
  data() {
    return {
      showModal: false,
      modalData: {
        title: "Успешно!",
        text: "Пароль был успешно изменен",
      },
      fields: {
        old_password: "",
        password: "",
        password2: "",
      },
      fieldsErrors: {
        incorrect_old_password: {
          value: false,
          message: "Старый пароль некорректный",
        },
        empty_old_password: {
          value: false,
          message: "Введите старый пароль",
        },
        empty_password: {
          value: false,
          message: "Введите новый пароль",
        },
        short_password: {
          value: false,
          message: "Новый пароль должен содержать минимум 8 символов",
        },
        empty_password2: {
          value: false,
          message: "Введите новый пароль еще раз",
        },
        different_passwords: {
          value: false,
          message: "Пароли не совпадают",
        },
      },
      currentErrorMessage: "",
    };
  },
  computed: {
    errorFieldOldPAssword() {
      return (
        this.fieldsErrors.incorrect_old_password.value ||
        this.fieldsErrors.empty_old_password.value
      );
    },
    errorFieldPassword() {
      return (
        this.fieldsErrors.empty_password.value ||
        this.fieldsErrors.short_password.value
      );
    },
    errorFieldPassword2() {
      return (
        this.fieldsErrors.empty_password2.value ||
        this.fieldsErrors.different_passwords.value
      );
    },
  },
  methods: {
    ...mapActions(["changePassword"]),
    resetErrors(fieldName) {
      if (fieldName === "password" || fieldName === "password2") {
        this.fieldsErrors.empty_password.value = false;
        this.fieldsErrors.short_password.value = false;
        this.fieldsErrors.empty_password2.value = false;
        this.fieldsErrors.different_passwords.value = false;
      } else if (fieldName === "old_password") {
        this.fieldsErrors.empty_old_password.value = false;
        this.fieldsErrors.incorrect_old_password.value = false;
      }

      this.currentErrorMessage = "";
    },
    validateForm() {
      let errors = [];
      if (!this.fields.old_password) {
        errors.push("empty_old_password");
      }
      if (!this.fields.password) {
        errors.push("empty_password");
      }
      if (this.fields.password.length < 8) {
        errors.push("short_password");
      }
      if (!this.fields.password2) {
        errors.push("empty_password2");
      }
      if (this.fields.password !== this.fields.password2) {
        errors.push("different_passwords");
      }
      if (errors.length > 0) {
        errors.forEach((item) => {
          this.fieldsErrors[item].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    onInputChange(field) {
      this.resetErrors(field);
    },
    onButtonClick() {
      if (this.validateForm()) {
        this.changePassword({
          data: {
            old_password: this.fields.old_password,
            password: this.fields.password,
          },
        }).then((res) => {
          if (res.status === 400) {
            if (res.data.old_password) {
              this.currentErrorMessage = this.fieldsErrors.incorrect_old_password.message;
              this.fieldsErrors.incorrect_old_password.value = true;
            }
          } else if (res.status === 200) {
            this.showModal = true;
            for (let item in this.fields) {
              this.fields[item] = "";
            }
          }
        });
      }
    },
  },
};
</script>
